import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-casto-generic-info',
  templateUrl: './generic-info.component.html',
})
export class GenericInfoComponent {
  constructor(public modalService: ModalService) { }

  get title(): string {
    return this.modalService.currentDatas?.title || '';
  }

  get img(): string | undefined {
    return this.modalService.currentDatas?.img;
  }

  get description(): string {
    return this.modalService.currentDatas?.description || '';
  }
}
